import React, { useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [images, setImages] = useState([]);

  // Dynamically fetch all images from the assets folder
  useEffect(() => {
    const loadImages = () => {
      const context = require.context('../../public/assets', false, /\.(jpg)$/i);
      const imageList = context.keys().map((key) => {
        return `/assets/${key.replace('./', '')}`;
      });
      setImages(imageList);
    };

    loadImages();
  }, []);

  useEffect(() => {
    if (images.length === 0) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative pt-20 overflow-hidden min-h-screen flex items-center justify-center">
      {/* Carousel Background Images */}
      <div className="hero-carousel">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Background ${index + 1}`}
            className={`hero-carousel-image ${index === currentImageIndex ? 'active' : ''}`}
          />
        ))}
      </div>

      {/* Overlay for opacity */}
      <div className="absolute inset-0 bg-black/40 z-10" />

      {/* Content */}
      <div className="relative z-20 container mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 lg:py-40">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
            Premium Heavy Machinery
            <span className="block text-blue-300 mt-2">Parts & Components</span>
          </h1>
          <p className="text-lg sm:text-xl text-white mb-10 leading-relaxed max-w-2xl mx-auto drop-shadow-md">
            Your trusted partner in supplying quality auto spare parts for heavy machinery. 
            We specialize in genuine and aftermarket parts for construction equipment, 
            trucks, and industrial vehicles.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={scrollToContact}
              className="group px-8 py-4 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-all duration-300 flex items-center gap-2 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              Get In Touch
              <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => document.getElementById('brands').scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-white text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-all duration-300 border-2 border-gray-200 hover:border-blue-600 hover:text-blue-600 shadow-md"
            >
              View Brands
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;